const form = document.getElementById( 'js-contact-form' );

if ( form && typeof arhikadAjax !== 'undefined' ) {
	const status = form.querySelector( '.contact-form__status' );
	const submit = form.querySelector( '.contact-form__submit' );

	form.addEventListener( 'submit', async ( e ) => {
		e.preventDefault();

		submit.disabled    = true;
		status.hidden      = true;
		status.className   = 'contact-form__status';

		const body = new FormData( form );
		body.append( 'action', 'contact_form_submit' );

		try {
			const res  = await fetch( arhikadAjax.ajaxurl, { method: 'POST', body } );
			const data = await res.json();

			status.hidden    = false;
			status.textContent = data.data.message;
			status.classList.add(
				data.success ? 'contact-form__status--success' : 'contact-form__status--error'
			);

			if ( data.success ) {
				form.reset();
			}
		} catch {
			status.hidden      = false;
			status.textContent = 'Something went wrong. Please try again.';
			status.classList.add( 'contact-form__status--error' );
		} finally {
			submit.disabled = false;
		}
	} );
}
